import { TextField, Tooltip } from '@arkestro/arkestro-design-system';

import styles from './rename-columns-drawer.module.scss';

interface BuyerOnlyColumnFieldProps {
  id: string;
  label: string;
  reason: string;
  value: string;
}

/**
 * A buyer-only column listed read-only beside the renameable ones, so its presence and its
 * effective name are visible without leaving the drawer. Same wrapper pattern as
 * `DisabledColumnField`: the tooltip listens on the wrapper because a disabled input swallows
 * pointer events, and the reason is also the input's accessible description.
 */
export const BuyerOnlyColumnField = ({ id, label, reason, value }: BuyerOnlyColumnFieldProps) => {
  const reasonElementId = `column-labels-buyer-only-reason-${id}`;

  return (
    <Tooltip title={reason}>
      <span className={styles.disabledField} data-testid={`column-labels-buyer-only-field-${id}`}>
        <TextField
          aria-describedby={reasonElementId}
          data-testid={`column-labels-buyer-only-input-${id}`}
          disabled
          label={label}
          value={value}
        />
        <span className={styles.srOnly} id={reasonElementId}>{reason}</span>
      </span>
    </Tooltip>
  );
};
